import { useEffect } from 'react'
import { BackHandler } from 'react-native'
import { User } from 'app/types'
import { useBlockUsername } from './commands'
import { ConfirmationModal, useToastController, ConfirmationModalOption } from '@my/ui'
import { userFeedQuery } from '../../screens/groups-feed-screen/queries'
import { getBlockedUserQuery, groupPostCommentsQuery } from '../../queries'

export interface BlockUsernameModalContainerProps {
  groupPostId?: string
  blockee: Pick<User, 'id'>
  open: boolean
  onOpenChange: (open: boolean) => void
}

export const BlockUsernameModalContainer = (props: BlockUsernameModalContainerProps) => {
  const [blockUsername, { loading }] = useBlockUsername()
  const toast = useToastController()

  useEffect(() => {
    const backAction = () => {
      props.onOpenChange(false);
      return props.open
    }

    const backHandler = BackHandler.addEventListener(
      "hardwareBackPress",
      backAction
    );

    return () => backHandler.remove();
  }, [])

  const handleSubmit = async () => {
    try {
      await blockUsername({
        variables: {
          blockeeId: props.blockee.id,
        },
        onCompleted: async (data) => {
          if (!data?.blockUser?.success) {
            throw new Error(data?.blockUser?.message || 'Failed to block username')
          }
          toast.show('Username blocked successfully')
        },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: getBlockedUserQuery,
            variables: {
              blockeeId: props.blockee.id,
            },
          },
          {
            query: userFeedQuery.query,
            variables: {
              ...userFeedQuery.defaultVariables,
            },
          },
          {
            ...(props?.groupPostId && {
              query: groupPostCommentsQuery.query,
              variables: {
                id: props.groupPostId,
                page: 1,
                limit: 20,
              },
            }),
          } as any,
        ].filter(Boolean),
      })
    } catch (error) {
      toast.show('Failed to block username', {
        burntOptions: { preset: 'error' },
      })
      console.log(error)
    }
    props.onOpenChange(false)
  }

  const options: ConfirmationModalOption[] = [
    {
      children: 'Yes, Save',
      theme: 'black',
      onPress: handleSubmit,
      loading: loading,
    },
    {
      children: 'No, Cancel',
      plain: true,
      onPress: () => props.onOpenChange(false),
    },
  ]

  return (
    <ConfirmationModal
      title="Are you sure you want to block this user?"
      open={props.open}
      onOpenChange={props.onOpenChange}
      onSubmit={handleSubmit}
      options={options}
    />
  )
}
